import { compose, setPropTypes, withPropsOnChange } from 'recompose';
import { stubFalse } from 'lodash';
import PropTypes from 'prop-types';
import getSurveyBlockValidationList from '../../../utils/getSurveyBlockValidationList';

const withTakerValidator = withPropsOnChange(
  stubFalse, // validation settings never change during taker experience @sinslav
  ({ readOnly = false, block: { required, formatValidationType } }) => ({
    validator: readOnly
      ? undefined
      : getSurveyBlockValidationList(required, formatValidationType),
  }),
);

export default compose(
  withTakerValidator,
  setPropTypes({
    readOnly: PropTypes.bool,
    block: PropTypes.shape({
      required: PropTypes.bool,
      formatValidationType: PropTypes.string,
    }),
  }),
);
